module.exports = __webpack_public_path__ + "static/media/OPTIV_rgb.c15b459e.svg";